const config = {
  apiKey: "AIzaSyBfj6rz1RCXopOy8FjyYD-B6uWIbK6uiqI",
  authDomain: "virtual-48f9e.firebaseapp.com",
  databaseURL: "https://virtual-48f9e.firebaseio.com",
  projectId: "virtual-48f9e",
  storageBucket: "virtual-48f9e.appspot.com",
  messagingSenderId: "1068488493638",
  storageBucket: "gs://virtual-48f9e.appspot.com/"
};

export default config


// WEBPACK FOOTER //
// ./src/store/modules/config.js